export const addHours = (date: any, hours: any) => {
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  return date.valueOf();
};
